import { render, staticRenderFns } from "./fdInventory23.vue?vue&type=template&id=59dac8ff"
import script from "./fdInventory23.vue?vue&type=script&lang=js"
export * from "./fdInventory23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports